// extracted by mini-css-extract-plugin
export default {"general":"AppQwep_general__FpAAo"};